export default __webpack_public_path__ + "images/marker-icon.bc8de8f04655e300d65889f937af475c.png";